import { Injectable } from '@angular/core';
import {TaskPageModel} from '../entities/PageModel';
import {Headers, Http} from '@angular/http';
import {ConnectionService} from './connection.service';
import {AppConfig} from '../app.config';

@Injectable()
export class EplannerTasksWithFilterService {
  apiUrl: string;


  get headers() : Headers {
    return this.connectionService.GetAuthorizationHeader();
  }

  constructor(private http: Http, private connectionService: ConnectionService, private config : AppConfig) {
    this.apiUrl = config.getConfig('endPointApiUrl');
  }



  getFilteredTasks(taskPageModel: TaskPageModel)
  {
    // /?taskPage1&jobNo=2&taskNo=3
    let url = this.apiUrl + 'api/eplannerTasksWithFilter/GetFilteredTasks';
    
    return this.http
      .post(url, taskPageModel, {headers: this.headers})
      .map(response => response.json() as TaskPageModel);
  }


}



// WEBPACK FOOTER //
// C:/Projects/ePlanner Maintenance/src/app/services/eplanner-tasks-with-filter.service.ts